<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-satisfaction-analysis`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M36 28a8 8 0 017.125 11.642l3.296 3.296a1 1 0 010 1.414l-1.697 1.697a1 1 0 01-1.414 0l-3.19-3.19A8 8 0 1136 28zM32.466 6C38.809 6 43.996 11.828 44 18.95a14.16 14.16 0 01-.929 5.05h-4.37c.89-1.752 1.299-3.266 1.299-5.047C39.997 13.94 36.489 10 32.466 10c-2.375 0-5.19 2.171-8.446 6.513C20.726 12.171 17.903 10 15.552 10 11.496 10 8 13.918 8 18.95c0 2.21.629 4.007 2.02 6.353.197.331.355.59.735 1.201.236.384.502.782.797 1.193 1.283 1.783 3.065 3.74 5.215 5.782a85.367 85.367 0 005.422 4.702c.517.413 1.22.96 1.8 1.404l.011-.009V44h-.011a2.291 2.291 0 01-1.487-.522c-.455-.366-10.851-7.883-15.154-14.878C5.86 26.206 4 23.217 4 18.95 4 11.8 9.182 6 15.552 6c2.153 0 4.023.68 5.645 1.888.97.756 1.907 1.73 2.81 2.923.826-1.207 1.762-2.182 2.806-2.924C28.438 6.68 30.316 6 32.466 6zM36 32a4 4 0 100 8 4 4 0 000-8z"/></svg>
</template>
<script>

export default {
  name: 'IconSatisfactionAnalysis',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
